<!-- ルートページ -->
<template>
  <!-- ▼ contents -->
  <div id="contents">
  </div>
</template>
<script>
import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'RootPage',
    // データ
    data() {
      return {}
    },
    // ライフサイクルフック: created
    created: function () {

      UtilityConsoleLog.consoleLog('RootPage::created')
      UtilityConsoleLog.consoleLog(this.$store.state.commonUserInfo.pram)
      if (this.$store.state.commonUserInfo.pram == '') {
        this.$router.push('/AdminLogin')
      }

      UtilityConsoleLog.consoleLog('RootPage::created')
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/RootPage.vue